import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { fetchVariableExplainer } from '../service/customReportExplainer'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { customReportArgumentsSelector, customReportDateSelector } from '../../../redux/context/customReports/selectors'
import { appLanguageSelector } from '../../../redux/app/selectors'

export const useVariableExplainer = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  const date = useSelector(customReportDateSelector)
  const lng = useSelector(appLanguageSelector)
  const args = useSelector(customReportArgumentsSelector)

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const fetch = useCallback(
    async (reportId: number, sectionId: number, variableId: number) => {
      setIsLoading(true)
      setError(null)

      try {
        if (!companyId) throw new Error('Missing companyId in context')
        if (!date) throw new Error('Missing report date in context')
        const result = await fetchVariableExplainer(companyId, reportId, sectionId, variableId, date, lng, args)
        return result
      } catch (err) {
        const e = err instanceof Error ? err : new Error('Unknown error occurred')
        setError(e)
        throw e
      } finally {
        setIsLoading(false)
      }
    },
    [companyId, date, lng, args]
  )

  return {
    fetch,
    isLoading,
    error
  }
}
